// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__19x4n"};